import React from 'react';

const Hero: React.FC = () => {
  return (
    <div className="container-fluid py-5 hero-header wow fadeIn" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-7 col-md-12">
            <h1 className="mb-3 text-white fst-italic">Alana English Center</h1>
            <h1 className="mb-5 display-4 text-white">bring a brighter future to your kids</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 